var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-about",attrs:{"id":"main","tabindex":"-1"}},[_c('h1',[_vm._v("About")]),_c('WorkRecent',{attrs:{"view":"cards"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }